export default "__VITE_ASSET__136e7e1a__"